<ion-header class="ion-no-border">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button mode="md" defaultHref="/reports"></ion-back-button>
    </ion-buttons>

    <smr-stylist-picker
      [stylistID]="stylistID"
      [readOnly]="readOnlyStylistPicker"
      [showAllStaff]="true"
      (onInit)="onStylistPickerInit($event)"
      (stylistSelect)="onStylistSelect($event)"
      cssClass="smr-stylist-picker-for-tipsreport"
    >
    </smr-stylist-picker>
  </ion-toolbar>
  <ion-toolbar>
    <salonmonster-date-picker
      [startDate]="startDate"
      [endDate]="endDate"
      [disabled]="isLoading"
      [hideGroupBy]="true"
      (rangeChanged)="rangeChanged($event)"
    ></salonmonster-date-picker>
  </ion-toolbar>
</ion-header>

<ion-content>
  <salonmonster-load-mask *ngIf="isLoading"></salonmonster-load-mask>

  <salonmonster-tap-retry
    *ngIf="errorOccurredWhileLoadingStylistPicker || errorOccurredWhileLoadingStats"
    (click)="onTapToReload()"
  ></salonmonster-tap-retry>

  <ng-container
    *ngIf="!isLoading && !errorOccurredWhileLoadingStylistPicker && !errorOccurredWhileLoadingStats"
  >
    <ng-container *ngIf="stylist.getID() == 0">
      <div margin-top>
        <ion-row>
          <ion-col class="hidden-lg-down" size="2"></ion-col>
          <ion-col size="12" size-xl="8" *ngIf="barChartData.length > 0">
            <canvas
              baseChart
              [datasets]="barChartData"
              [labels]="barChartLabels"
              [options]="barChartOptions"
              [legend]="barChartLegend"
              [type]="barChartType"
            >
            </canvas>
          </ion-col>
          <ion-col class="hidden-lg-down" size="2"></ion-col>
        </ion-row>
        <ion-row>
          <p-table
            styleClass="sticky-table"
            [columns]="cols"
            [value]="allStaffRows"
            sortMode="multiple"
            [responsive]="true"
          >
            <ng-template pTemplate="caption">
              <div class="ui-helper-clearfix">
                <div class="ui-align-items">
                  <span class="export">Export to:</span>
                  <ion-button
                    fill="outline"
                    (click)="exportExcel('all')"
                    style="margin-right: 0.5em"
                    >Excel</ion-button
                  >
                  <ion-button fill="outline" (click)="exportPdf('all')">
                    PDF
                  </ion-button>
                </div>
              </div>
            </ng-template>
            <ng-template pTemplate="header" let-columns>
              <tr>
                <th [pSortableColumn]="'stylistFullName'">
                  Stylist
                  <p-sortIcon [field]="'stylistFullName'"></p-sortIcon>
                </th>
                <th [pSortableColumn]="'totalTips'">
                  <div class="text-align-center">
                    Amount
                    <p-sortIcon [field]="'totalTips'"></p-sortIcon>
                  </div>
                </th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-stylistLineitems>
              <tr>
                <td>{{stylistLineitems["stylistFullName"] }}</td>
                <td class="center-numbers-table-u_x_wider-padding">
                  {{stylistLineitems["totalTips"].toFixed(2) |
                  salonMonsterCurrency}}
                </td>
              </tr>
            </ng-template>
            <ng-template pTemplate="footer">
              <tr>
                <td><strong>Total</strong></td>
                <td class="center-numbers-table-u_x_wider-padding">
                  {{ summaryTotalTips()| salonMonsterCurrency}}
                </td>
              </tr>
            </ng-template>
          </p-table>
        </ion-row>
      </div>
    </ng-container>

    <ng-container *ngIf="stylist.getID() != 0">
      <div margin-top>
        <p-table
          styleClass="sticky-table"
          [columns]="cols"
          [value]="stylistTips"
          sortMode="multiple"
          [responsive]="true"
        >
          <ng-template pTemplate="caption">
            <div class="ui-helper-clearfix">
              <div class="ui-align-items">
                <span class="export">Export to:</span>
                <ion-button
                  fill="outline"
                  (click)="exportExcel('one')"
                  style="margin-right: 0.5em"
                  >Excel</ion-button
                >
                <ion-button fill="outline" (click)="exportPdf('one')">
                  PDF
                </ion-button>
              </div>
            </div>
          </ng-template>
          <ng-template pTemplate="header" let-columns>
            <tr>
              <th *ngFor="let col of columns" [pSortableColumn]="col.field">
                <div
                  [ngClass]="{'text-align-center': col.field ==='tipsTotal'}"
                >
                  {{col.header}}
                  <p-sortIcon [field]="col.field"></p-sortIcon>
                </div>
              </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-stat let-columns="columns">
            <tr>
              <td
                [ngClass]="{'center-numbers-table-wider-padding': col.field ==='tipsTotal'}"
                *ngFor="let col of columns"
              >
                <!--span class="ui-column-title">{{ col.header }}</!--span-->
                {{col.field === "tipsTotal" ? (stat[col.field] |
                salonMonsterCurrency) : ( col.field === "datetime" ?
                (stat[col.field] | salonMonsterDate: 'ddd, MMMM D, Y') :
                stat[col.field])}}
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="footer">
            <tr>
              <td><strong>Total</strong></td>
              <td></td>
              <td></td>
              <td>{{ (stylistTotalTip | salonMonsterCurrency) }}</td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </ng-container>
  </ng-container>
</ion-content>
